import { createSlice } from "@reduxjs/toolkit";

const ModalSlice = createSlice({
    name: "modalSlice",
    initialState: {
        loginModal: false
    },
    reducers: {
        openLoginModal: (state) => {
            state.loginModal = true
        },
        closeLoginModal: (state) => {
            state.loginModal = false
        },
    }
})

export const { openLoginModal, closeLoginModal } = ModalSlice.actions

export default ModalSlice.reducer